export type HomeSelection = { kind: 'poster' | 'theme'; value: string }
type ArrivalLocation = { pathname: string; search: string; hash: string }
export const HOME_ALIASES = ['/', '/home', '/universe', '/united-square', '/hub'] as const

function queryParts(search: string) {
  return search ? search.replace(/^\?/, '').split('&') : []
}

function selectionPart(part: string): HomeSelection | null {
  const entry = new URLSearchParams(part).entries().next().value
  if (!entry || (entry[0] !== 'poster' && entry[0] !== 'theme')) return null
  return { kind: entry[0], value: entry[1].trim() }
}

export function readHomeSelection(search: string): HomeSelection | null {
  const selections = queryParts(search).map(selectionPart)
  // First nonempty value wins within a managed key; poster wins over theme.
  return (
    selections.find(item => item?.kind === 'poster' && item.value) ||
    selections.find(item => item?.kind === 'theme' && item.value) ||
    null
  )
}

export function withoutHomeSelection(search: string): string {
  const remaining = queryParts(search).filter(part => !selectionPart(part))
  return remaining.length ? `?${remaining.join('&')}` : ''
}

export function isHomeArrivalPath(pathname: string) {
  const path = pathname.replace(/\/$/, '').toLowerCase() || '/'
  return (HOME_ALIASES as readonly string[]).includes(path) || /^\/p\/[^/]+$/.test(path)
}

export function canonicalHomeArrival(location: ArrivalLocation): ArrivalLocation {
  const qr = /^\/p\/([^/]+)\/?$/i.exec(location.pathname)
  let selection = readHomeSelection(location.search)
  if (qr) {
    // A path '+' is literal. Decode once, then encode as a query value once.
    let slug = qr[1]
    try {
      slug = decodeURIComponent(slug)
    } catch {
      /* Keep malformed input visible as an unknown slug. */
    }
    selection = { kind: 'poster', value: slug }
  }
  let search = withoutHomeSelection(location.search)
  if (selection)
    search += `${search ? '&' : '?'}${selection.kind}=${encodeURIComponent(selection.value)}`
  return { pathname: '/home', search, hash: location.hash }
}
